import { InMemoryCache, makeVar } from '@apollo/client'

import * as storageUtils from '@/helpers/storage-utils'
import { AppSections } from '@/models/auth'

export const appSectionVar = makeVar(storageUtils.getApplicationSection() || AppSections.RISK_MANAGEMENT)
export const tablesInitialStateVar = makeVar([])
export const tablesV2StateVar = makeVar([])
// Risk management
export const prospectListTabVar = makeVar('all')
export const prospectDetailsTabVar = makeVar('profile')
export const prospectDebtorDetailsTabVar = makeVar('profile')
export const prospectKycDetailsTabVar = makeVar('profile')
export const riskManagementReportsTabVar = makeVar('week')
export const stopListTabVar = makeVar('company')
export const stopListCompanyDetailsTabVar = makeVar('profile')
export const stopListPersonDetailsTabVar = makeVar('profile')
export const limitIncreaseListTabVar = makeVar('all')
export const limitIncreaseDetailsTabVar = makeVar('profile')
export const limitIncreaseHistoryDetailsTabVar = makeVar('profile')
export const debtorLimitDetailsTabVar = makeVar('profile')
export const annualReviewListTabVar = makeVar('all')
export const annualReviewDetailsTabVar = makeVar('profile')
export const annualReviewDebtorDetailsTabVar = makeVar('profile')
export const annualReviewKycDetailsTabVar = makeVar('profile')
export const prospectContractDetailsTabVar = makeVar('overview')
// Factoring
export const clientsListTabVar = makeVar('all')
export const clientDetailsTabVar = makeVar('profile')
export const clientDebtorDetailsTabVar = makeVar('relations')
export const contractDetailsTabVar = makeVar('overview')
export const loanBookContractDetailsTabVar = makeVar('overview')
export const debtorsListTabVar = makeVar('all')
export const debtorDetailsTabVar = makeVar('profile')
export const invoicesListTabVar = makeVar('new')
export const invoiceDetailsTabVar = makeVar('overview')
export const factoringNotesListTabVar = makeVar('purchase')
export const debtCollectionListTabVar = makeVar('assignedToMe')
export const debtCollectionDetailsTabVar = makeVar('invoices')
export const clientRequirementsTabVar = makeVar('addDebtor')
export const outstandingVerificationTasksTabVar = makeVar('all')
export const outstandingVerificationTaskDetailsTabVar = makeVar('overview')
export const bulkExternalVerificationTasksTabVar = makeVar('inVerification')
export const bulkExternalVerificationTaskDetailsTabVar = makeVar('overview')
export const aiTasksTabVar = makeVar('all')
export const aiTaskDetailsTabVar = makeVar('overview')
export const riskMonitoringTasksTabVar = makeVar('all')
export const riskMonitoringTaskDetailsTabVar = makeVar('overview')
// Payments
export const bankStatementsListTabVar = makeVar('all')
export const generalLedgersTabVar = makeVar('ledgers')
export const bankStatementDetailsTabVar = makeVar('incomingPayments')
export const paymentsReportsTabVar = makeVar('notes')
export const payoutListTabVar = makeVar('factoring')
export const generalLedgersReconciliationsTabVar = makeVar('reconciliations')
// Loan book
export const loansListTabVar = makeVar('new')
export const creditLineListTabVar = makeVar('new')
export const reverseFactoringListTabVar = makeVar('new')
export const loansDetailsTabVar = makeVar('overview')
export const creditLineDetailsTabVar = makeVar('overview')
export const reverseFactoringDetailsTabVar = makeVar('overview')
export const loanBookNotesListTabVar = makeVar('payoutNotes')
export const loanBookReportsListTabVar = makeVar('userReports')
export const loanBookDebtCollectionListTabVar = makeVar('assignedToMe')
export const loanBookDebtCollectionDetailsTabVar = makeVar('openTasks')
// Investment
export const investorsListTabVar = makeVar('new')
export const investmentPlansListTabVar = makeVar('active')
export const investorDetailsTabVar = makeVar('profile')
export const investorKYCIdentityDetailsTabVar = makeVar('profile')
export const offersListTabVar = makeVar('new')
export const offerDetailsTabVar = makeVar('overview')
export const investorTaskManagerTabVar = makeVar('assignedToMe')
export const investorNotesListTabVar = makeVar('withdrawal')

// System preferences
export const systemTabVar = makeVar('users')
export const reportingTabVar = makeVar('brokerCommissions')

// Client Portal
export const clientPortalDebtorListTabVar = makeVar('all')
export const clientPortalDebtorDetailsTabVar = makeVar('profile')
export const clientPortalNotesTabVar = makeVar('purchase')
export const clientPortalHomeTabVar = makeVar('profile')
export const clientPortalInvoicesListTabVar = makeVar('new')
export const clientPortalInvoiceDetailsTabVar = makeVar('overview')
export const clientPortalLoanBookListTabVar = makeVar('all')
export const clientPortalLoanBookDetailsTabVar = makeVar('overview')
export const clientPortalLoanBookContractDetailsTabVar = makeVar('overview')
export const clientPortalReportsTabVar = makeVar('client')

export const resetReactiveVariables = (): void => {
  tablesInitialStateVar([])
  tablesV2StateVar([])
  // Risk management
  prospectListTabVar('all')
  prospectDetailsTabVar('profile')
  prospectDebtorDetailsTabVar('profile')
  prospectKycDetailsTabVar('profile')
  riskManagementReportsTabVar('week')
  stopListTabVar('company')
  stopListCompanyDetailsTabVar('profile')
  stopListPersonDetailsTabVar('profile')
  limitIncreaseListTabVar('all')
  limitIncreaseDetailsTabVar('profile')
  limitIncreaseHistoryDetailsTabVar('profile')
  debtorLimitDetailsTabVar('profile')
  annualReviewListTabVar('all')
  annualReviewDebtorDetailsTabVar('profile')
  annualReviewKycDetailsTabVar('profile')
  prospectContractDetailsTabVar('overview')
  // Factoring
  clientsListTabVar('all')
  clientDetailsTabVar('profile')
  clientDebtorDetailsTabVar('relations')
  contractDetailsTabVar('overview')
  loanBookContractDetailsTabVar('overview')
  debtorsListTabVar('all')
  debtorDetailsTabVar('profile')
  invoicesListTabVar('new')
  invoiceDetailsTabVar('overview')
  factoringNotesListTabVar('purchase')
  debtCollectionListTabVar('assignedToMe')
  debtCollectionDetailsTabVar('invoices')
  clientRequirementsTabVar('addDebtor')
  outstandingVerificationTasksTabVar('all')
  outstandingVerificationTaskDetailsTabVar('overview')
  bulkExternalVerificationTasksTabVar('inVerification')
  bulkExternalVerificationTaskDetailsTabVar('overview')
  aiTaskDetailsTabVar('overview')
  riskMonitoringTasksTabVar('all')
  riskMonitoringTaskDetailsTabVar('overview')
  // Payment
  bankStatementsListTabVar('all')
  bankStatementDetailsTabVar('incomingPayments')
  generalLedgersTabVar('ledgers')
  paymentsReportsTabVar('notes')
  payoutListTabVar('factoring')
  generalLedgersReconciliationsTabVar('reconciliations')
  // Loan book
  loansListTabVar('new')
  creditLineListTabVar('new')
  reverseFactoringListTabVar('new')
  loansDetailsTabVar('overview')
  creditLineDetailsTabVar('overview')
  reverseFactoringDetailsTabVar('overview')
  loanBookNotesListTabVar('payoutNotes')
  loanBookReportsListTabVar('userReports')
  loanBookDebtCollectionListTabVar('assignedToMe')
  loanBookDebtCollectionDetailsTabVar('openTasks')
  // System preferences
  reportingTabVar('brokerCommissions')
  systemTabVar('users')
  // Investment
  investorsListTabVar('new')
  investmentPlansListTabVar('active')
  investorDetailsTabVar('profile')
  investorNotesListTabVar('withdrawal')
  investorKYCIdentityDetailsTabVar('profile')
  offersListTabVar('new')
  offerDetailsTabVar('overview')
  investorTaskManagerTabVar('assignedToMe')
  // Client Portal
  clientPortalDebtorListTabVar('all')
  clientPortalDebtorDetailsTabVar('profile')
  clientPortalNotesTabVar('purchase')
  clientPortalHomeTabVar('profile')
  clientPortalInvoicesListTabVar('new')
  clientPortalInvoiceDetailsTabVar('overview')
  clientPortalLoanBookListTabVar('all')
  clientPortalLoanBookDetailsTabVar('overview')
  clientPortalLoanBookContractDetailsTabVar('overview')
  clientPortalReportsTabVar('client')

  return
}

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getAppSectionVar: {
          read() {
            return appSectionVar()
          },
        },
        getTablesInitialState: {
          read() {
            return tablesInitialStateVar()
          },
        },
        getTablesV2State: {
          read() {
            return tablesV2StateVar()
          },
        },
        // Risk management
        selectProspectListTab: {
          read() {
            return prospectListTabVar()
          },
        },
        selectProspectDetailsTab: {
          read() {
            return prospectDetailsTabVar()
          },
        },
        selectProspectDebtorDetailsTab: {
          read() {
            return prospectDebtorDetailsTabVar()
          },
        },
        selectProspectKycDetailsTab: {
          read() {
            return prospectKycDetailsTabVar()
          },
        },
        selectRiskManagementReportsTab: {
          read() {
            return riskManagementReportsTabVar()
          },
        },
        selectStopListTab: {
          read() {
            return stopListTabVar()
          },
        },
        selectStopListCompanyDetailsTab: {
          read() {
            return stopListCompanyDetailsTabVar()
          },
        },
        selectStopListPersonDetailsTab: {
          read() {
            return stopListPersonDetailsTabVar()
          },
        },
        selectLimitIncreaseListTabVar: {
          read() {
            return limitIncreaseListTabVar()
          },
        },
        selectLimitIncreaseDetailsTabVar: {
          read() {
            return limitIncreaseDetailsTabVar()
          },
        },
        selectLimitIncreaseHistoryDetailsTabVar: {
          read() {
            return limitIncreaseHistoryDetailsTabVar()
          },
        },
        selectDebtorLimitIncreaseDetailsTabVar: {
          read() {
            return debtorLimitDetailsTabVar()
          },
        },
        selectAnnualReviewListTab: {
          read() {
            return annualReviewListTabVar()
          },
        },
        selectAnnualReviewDetailsTabVar: {
          read() {
            return annualReviewDetailsTabVar()
          },
        },
        selectAnnualReviewDebtorDetailsTabVar: {
          read() {
            return annualReviewDebtorDetailsTabVar()
          },
        },
        selectAnnualReviewKycDetailsTab: {
          read() {
            return annualReviewKycDetailsTabVar()
          },
        },
        selectProspectContractDetailsTab: {
          read() {
            return prospectContractDetailsTabVar()
          },
        },
        // Factoring
        selectClientsListTab: {
          read() {
            return clientsListTabVar()
          },
        },
        selectClientDetailsTab: {
          read() {
            return clientDetailsTabVar()
          },
        },
        selectClientDebtorDetailsTabVar: {
          read() {
            return clientDebtorDetailsTabVar()
          },
        },
        selectContractDetailsTab: {
          read() {
            return contractDetailsTabVar()
          },
        },
        selectLoanBookContractDetailsTab: {
          read() {
            return loanBookContractDetailsTabVar()
          },
        },
        selectDebtorsListTab: {
          read() {
            return debtorsListTabVar()
          },
        },
        selectDebtorDetailsTab: {
          read() {
            return debtorDetailsTabVar()
          },
        },
        selectInvoicesListTab: {
          read() {
            return invoicesListTabVar()
          },
        },
        selectInvoicesDetailsTab: {
          read() {
            return invoiceDetailsTabVar()
          },
        },
        selectFactoringNotesListTab: {
          read() {
            return factoringNotesListTabVar()
          },
        },
        selectDebtCollectionListTab: {
          read() {
            return debtCollectionListTabVar()
          },
        },
        selectDebtCollectionDetailsTab: {
          read() {
            return debtCollectionListTabVar()
          },
        },
        selectClientRequirementsTab: {
          read() {
            return clientRequirementsTabVar()
          },
        },
        selectOutstandingVerificationTasksTab: {
          read() {
            return outstandingVerificationTasksTabVar()
          },
        },
        selectOutstandingVerificationTaskDetailsTab: {
          read() {
            return outstandingVerificationTaskDetailsTabVar()
          },
        },
        selectBulkExternalVerificationTasksTab: {
          read() {
            return bulkExternalVerificationTasksTabVar()
          },
        },
        selectBulkExternalVerificationTaskDetailsTab: {
          read() {
            return bulkExternalVerificationTaskDetailsTabVar()
          },
        },
        selectAiTaskDetailsTab: {
          read() {
            return aiTaskDetailsTabVar()
          },
        },
        // Payments
        selectBankStatementsListTab: {
          read() {
            return bankStatementsListTabVar()
          },
        },
        selectBankStatementDetailsTab: {
          read() {
            return bankStatementDetailsTabVar()
          },
        },
        selectGeneralLedgersTabVar: {
          read() {
            return generalLedgersTabVar()
          },
        },
        selectGeneralLedgersReconciliationsTabVar: {
          read() {
            return generalLedgersReconciliationsTabVar()
          },
        },
        selectPaymentsReportsTabVar: {
          read() {
            return paymentsReportsTabVar()
          },
        },
        selectPayoutListVar: {
          read() {
            return payoutListTabVar()
          },
        },
        // Loan book
        selectLoansListTabVar: {
          read() {
            return loansListTabVar()
          },
        },
        selectCreditLineListTabVar: {
          read() {
            return creditLineListTabVar()
          },
        },
        selectReverseFactoringListTabVar: {
          read() {
            return reverseFactoringListTabVar()
          },
        },
        selectLoansDetailsTabVar: {
          read() {
            return loansDetailsTabVar()
          },
        },
        selectCreditLineDetailsTabVar: {
          read() {
            return creditLineDetailsTabVar()
          },
        },
        selectReverseFactoringDetailsTabVar: {
          read() {
            return reverseFactoringDetailsTabVar()
          },
        },
        selectLoanBookNotesListTabVar: {
          read() {
            return loanBookNotesListTabVar()
          },
        },
        selectLoanBookDebtCollectionListTabVar: {
          read() {
            return loanBookDebtCollectionListTabVar()
          },
        },
        selectLoanBookDebtCollectionDetailsTabVar: {
          read() {
            return loanBookDebtCollectionDetailsTabVar()
          },
        },
        selectLoanBookReportsListTabVar: {
          read() {
            return loanBookReportsListTabVar()
          },
        },
        // System preferences
        selectSystemTab: {
          read() {
            return systemTabVar()
          },
        },
        selectReportingTab: {
          read() {
            return reportingTabVar()
          },
        },
        // Investment
        selectInvestorsListTab: {
          read() {
            return investorsListTabVar()
          },
        },
        selectInvestmentPlansListTab: {
          read() {
            return investmentPlansListTabVar()
          },
        },
        selectInvestorDetailsTab: {
          read() {
            return investorDetailsTabVar()
          },
        },
        selectInvestorNotesListTabVar: {
          read() {
            return investorNotesListTabVar()
          },
        },
        selectInvestorKYCIdentityDetailsTab: {
          read() {
            return investorKYCIdentityDetailsTabVar()
          },
        },
        selectOffersListTab: {
          read() {
            return offersListTabVar()
          },
        },
        selectOffersDetailsTab: {
          read() {
            return offerDetailsTabVar()
          },
        },
        selectInvestorTaskManagerTab: {
          read() {
            return investorTaskManagerTabVar()
          },
        },
        // Client Portal
        selectClientPortalNotesTab: {
          read() {
            return clientPortalNotesTabVar()
          },
        },
        selectClientPortalDebtorDetailsTab: {
          read() {
            return clientPortalNotesTabVar()
          },
        },
        selectClientPortalHomeTab: {
          read() {
            return clientPortalHomeTabVar()
          },
        },
        selectClientPortalInvoicesListTab: {
          read() {
            return clientPortalInvoicesListTabVar()
          },
        },
        selectClientPortalInvoiceDetailsTab: {
          read() {
            return clientPortalInvoiceDetailsTabVar()
          },
        },
        selectClientPortalDebtorListTab: {
          read() {
            return clientPortalDebtorListTabVar()
          },
        },
        selectClientPortalLoanBookListTabVar: {
          read() {
            return clientPortalLoanBookListTabVar()
          },
        },
        selectClientPortalLoanBookDetailsTabVar: {
          read() {
            return clientPortalLoanBookDetailsTabVar()
          },
        },
        selectClientPortalLoanBookContractDetailsTabVar: {
          read() {
            return clientPortalLoanBookContractDetailsTabVar()
          },
        },
        selectClientPortalReportsTabVar: {
          read() {
            return clientPortalReportsTabVar()
          },
        },
      },
    },
  },
})
